<template>
  <md-table
    v-model="regions"
    class="table-striped"
    table-header-color="primary"
  >
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <md-table-cell md-label="Name">
        <router-link
          :to="{ name: 'Contractor Region', params: { regionId: item.id } }"
          >{{ item.name }}</router-link
        >
      </md-table-cell>
      <md-table-cell class="text-right">
        <edit-button
          :isSmall="true"
          @edit-click="editContractorRegion(item.id)"
        ></edit-button>
      </md-table-cell>
    </md-table-row>
    <md-table-empty-state
      md-label="No Contractor Regions Found"
    ></md-table-empty-state>
  </md-table>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ContractorRegionList",
  computed: {
    ...mapGetters({
      regions: "data-management-contractor/regions"
    })
  },
  methods: {
    editContractorRegion(id) {
      this.$router.push({
        name: "Edit Contractor Region",
        params: { regionId: id }
      });
    }
  }
};
</script>

<style>
.text-right .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}
</style>
